export default __webpack_public_path__ + "static/media/aUSDO.a86ed760.svg";